module.exports = __webpack_public_path__ + "static/ff-saleslanding-icon-oil.83a27c15.png";